/** Teksty nagłówków widoków (Hero 2.0): grupa admin / operacje. Klucze: heroAdmin.* */
export const heroAdminPl = {
  activity: {
    visits: 'Wizyty zrealizowane',
    visitsHint: '{missed} niezrealizowanych · {planned} zaplanowanych',
    coverage: 'Pokrycie portfela',
    coverageHint: '{onTime} z {portfolio} klientów w kadencji',
    gps: 'Wizyty z GPS',
    gpsHint: '{gps} z {all} wizyt',
    anomalies: 'Anomalie',
    anomaliesHint: '{overdue} zaległych zadań',
    insightAnomalies: 'Anomalie do weryfikacji: {count}, najczęściej „{type}”.',
    insightCoverageRep: 'Pokrycie portfela {pct} — najsłabiej u {name} ({value}).',
    insightCoverage: 'Pokrycie portfela {pct} — {count} klientów czeka na kontakt w ramach kadencji.',
    insightGps: 'Tylko {pct} wizyt potwierdzonych GPS — pozostałe wpisano ręcznie.',
    insightOverdue: '{count} zaległych zadań czeka na zamknięcie.',
    insightOk: 'Praca w terenie w normie: pokrycie {coverage}, GPS {gps}, brak anomalii.',
    insightEmpty: 'Brak aktywności terenowej w wybranym okresie.',
    seeLive: 'Mapa na żywo',
    actions: { live: 'Mapa na żywo', funnel: 'Lejek leadów', bonus: 'Premie', customers: 'Klienci' },
  },
  funnel: {
    insightDrop: 'Największy spadek: {from} → {to} — dalej przechodzi tylko {pct} leadów.',
    insightStuck: 'Leady najdłużej zalegają na etapie „{stage}” (śr. {days} dni).',
    insightWin: 'Skuteczność {pct}: {won} wygranych, {lost} utraconych.',
    insightOpen: 'W lejku czeka {count} otwartych leadów o potencjale {amount}.',
    insightEmpty: 'Brak leadów dla wybranych filtrów.',
    seeLeads: 'Zobacz leady',
    actions: { leads: 'Leady', customers: 'Klienci', newCustomer: 'Nowy klient', activity: 'Aktywność' },
  },
  bonus: {
    pool: 'Wykorzystanie puli',
    poolHint: 'pula bazowa {amount}',
    forPeriod: 'za {month}',
    gain: 'Możliwy przyrost',
    gainHint: 'po najlepszym kroku',
    gainNone: 'maksimum osiągnięte',
    insightBelow: '{count} z {total} handlowców nie przekracza progu sprzedaży — bez składnika sprzedażowego.',
    insightPenalty: '{count} handlowców traci część premii przez niespełnione aktywności obowiązkowe.',
    insightTop: 'Najwyższa premia: {name} — {amount}.',
    insightTip: 'Najszybszy sposób na wyższą premię: {tip} (+{gain}).',
    insightEmpty: 'Brak handlowców do wyliczenia premii w tym okresie.',
    actions: { activity: 'Aktywność', mine: 'Moje wyniki', team: 'Zespół' },
  },
  live: {
    online: 'Handlowcy online',
    onlineHint: 'z {total} w zakresie',
    onVisit: 'Na wizycie',
    onVisitHint: 'średnio {duration} u klienta',
    onVisitNone: 'żadna wizyta w toku',
    visits: 'Wizyty dziś',
    visitsHint: '{inProgress} w toku · {planned} do zrobienia',
    gps: 'Bez świeżego sygnału',
    gpsHint: '{none} bez GPS · {lost} bez sygnału > 1 h',
    gpsOk: 'wszyscy raportują pozycję',
    insightLost: 'Brak sygnału GPS od ponad godziny: {names}.',
    insightLong: 'Najdłuższa wizyta trwa {duration} — {rep} u klienta {customer}.',
    insightIdle: 'Nikt nie jest teraz na wizycie, a online jest {online} handlowców.',
    insightOk: 'Wszyscy handlowcy mają aktywny sygnał, na wizycie: {onVisit}.',
    locate: 'Pokaż na mapie',
    actions: { fit: 'Cała mapa', customers: 'Klienci', alerts: 'Alerty', activity: 'Aktywność' },
  },
  ai: {
    questions: 'Pytania w miesiącu',
    questionsHint: 'dziś: {today}',
    cost: 'Koszt w miesiącu',
    costHint: 'budżet {amount}',
    costNoBudget: 'bez limitu budżetu',
    projection: 'Prognoza na koniec miesiąca',
    projectionHint: '{pct} budżetu',
    projectionDays: 'dzień {elapsed} z {total}',
    tokens: 'Tokeny',
    tokensHint: '{calls} wywołań · cache {cache}',
    insightOver: 'Prognoza kosztu {projection} przekracza budżet {budget} — ogranicz użycie lub zwiększ limit.',
    insightNear: 'Wykorzystano już {pct} budżetu miesięcznego (koszt {cost}).',
    insightMock: 'Asystent działa w trybie demonstracyjnym (mock) — koszty są symulowane.',
    insightTopUser: 'Najaktywniejszy użytkownik: {name} — {questions} pytań, {cost} ({share} kosztów).',
    insightEmpty: 'Brak użycia asystenta AI w tym miesiącu.',
    actions: { users: 'Użytkownicy', board: 'Dashboard zarządu' },
  },
  soon: {
    status: 'Status',
    statusValue: 'Wkrótce',
    statusHint: 'moduł w przygotowaniu',
    milestone: 'Planowany etap',
    insight: 'Ten moduł jest w przygotowaniu (etap {milestone}). Do tego czasu skorzystaj z pozostałych widoków.',
    actions: { home: 'Mój dzień', analytics: 'Analityka' },
  },
  hub: {
    available: 'Dostępne dashboardy',
    availableHint: 'z {total} w systemie',
    scope: 'Zakres danych',
    scopeOrg: 'Cała organizacja',
    scopeTeam: 'Zespół',
    scopeOwn: 'Własne dane',
    scopeHint: 'wg Twoich uprawnień',
    insightBoard: 'Zacznij od dashboardu Zarządu — zbiorcze wyniki całej organizacji.',
    insightTeam: 'Zacznij od dashboardu Zespołu — wyniki handlowców na tle celów.',
    insightRep: 'Zacznij od „Moje wyniki” — Twoja sprzedaż, cele i wizyty.',
    insightOpen: 'Otwórz',
    pick: 'Wybierz dashboard',
    pickHint: 'Każdy widok respektuje Twój zakres danych i uprawnienia.',
    desc: {
      board: 'Wyniki całej organizacji: sprzedaż, marża, cele i trendy.',
      team: 'Wyniki zespołu i handlowców na tle celów.',
      rep: 'Twoja sprzedaż, realizacja celu i klienci.',
      activity: 'Wizyty, pokrycie portfela, dyscyplina GPS i anomalie.',
      funnel: 'Droga leadów do pierwszego zamówienia i skuteczność źródeł.',
      bonus: 'Symulator premii i „Moja premia”.',
      customers: 'Segmenty, ABC, ryzyko odejścia i wzorce zakupowe.',
      products: 'Produkty, kategorie, koszyk i rotacja asortymentu.',
      margin: 'Marża wg klientów, produktów i okresów.',
      forecasts: 'Prognozy sprzedaży i realizacji celów.',
      receivables: 'Należności, przeterminowania i ryzyko płatnicze.',
      profitability: 'Rentowność klientów i tras dostaw.',
    },
  },
  users: {
    total: 'Konta w systemie',
    totalHint: 'ról w użyciu: {roles}',
    active: 'Aktywne',
    activeHint: '{share} kont',
    inactive: 'Nieaktywne',
    inactiveHint: 'zablokowane konta',
    lastLogin: 'ostatnie logowanie {when}',
    twoFa: 'Weryfikacja 2FA',
    twoFaHint: '{count} z {total} aktywnych kont',
    insightAdmin2fa: 'Administratorzy bez weryfikacji dwuskładnikowej: {count}. Włącz 2FA przed przekazaniem dostępu klientowi.',
    insightInactive: 'Nieaktywne konta: {count}. Zablokowani użytkownicy nie mogą się zalogować.',
    insightOk: 'Wszystkie konta są aktywne, a dostępy zgodne z rolami.',
    actions: { roles: 'Role i uprawnienia', audit: 'Dziennik audytu' },
  },
  roles: {
    roles: 'Role',
    rolesHint: 'od zarządu po windykację',
    permissions: 'Uprawnienia',
    permissionsHint: 'w katalogu systemu',
    groups: 'Obszary',
    groupsHint: 'klienci, BI, akceptacje…',
    narrowest: 'Najwęższa rola',
    insight: 'Zakres danych (własne, zespół, cała firma) egzekwuje serwer — widok ról jest tylko do odczytu.',
    actionUsers: 'Użytkownicy',
  },
  audit: {
    total: 'Zdarzenia w dzienniku',
    totalHint: 'łącznie, nowe na górze',
    day: 'Ostatnie 24 godz.',
    dayHint: 'działało {actors} użytkowników',
    logins: 'Logowania',
    loginsHint: 'udane, 24 godz.',
    failed: 'Nieudane logowania',
    failedHint: '24 godz.',
    insightFailed: 'Nieudane logowania w ostatniej dobie: {count}. Sprawdź adresy IP i konta, których dotyczą.',
    insightSomeFailed: 'Pojedyncze nieudane logowania w ostatniej dobie: {count}.',
    insightOk: 'Brak nieudanych logowań w ostatniej dobie.',
  },
  help: {
    insight: 'Zacznij od „Mojego dnia” — zadania, alerty i postęp celu w jednym miejscu. Skrót Ctrl K otwiera wyszukiwarkę.',
    actions: { myDay: 'Mój dzień', customers: 'Klienci', tasks: 'Zadania', analytics: 'Analityka' },
  },
  legal: {
    insight: 'Dokumenty w wersji demonstracyjnej — wiążące wersje zostaną podpisane przed uruchomieniem produkcyjnym.',
    actions: { help: 'Pomoc i FAQ' },
  },
};

export const heroAdminEn: typeof heroAdminPl = {
  activity: {
    visits: 'Completed visits',
    visitsHint: '{missed} missed · {planned} planned',
    coverage: 'Portfolio coverage',
    coverageHint: '{onTime} of {portfolio} customers within cadence',
    gps: 'Visits with GPS',
    gpsHint: '{gps} of {all} visits',
    anomalies: 'Anomalies',
    anomaliesHint: '{overdue} overdue tasks',
    insightAnomalies: 'Anomalies to verify: {count}, most often “{type}”.',
    insightCoverageRep: 'Portfolio coverage is {pct} — weakest for {name} ({value}).',
    insightCoverage: 'Portfolio coverage is {pct} — {count} customers are waiting for contact within their cadence.',
    insightGps: 'Only {pct} of visits are GPS-confirmed — the rest were entered manually.',
    insightOverdue: '{count} overdue tasks are waiting to be closed.',
    insightOk: 'Field work looks healthy: coverage {coverage}, GPS {gps}, no anomalies.',
    insightEmpty: 'No field activity in the selected period.',
    seeLive: 'Live map',
    actions: { live: 'Live map', funnel: 'Lead funnel', bonus: 'Bonuses', customers: 'Customers' },
  },
  funnel: {
    insightDrop: 'Biggest drop: {from} → {to} — only {pct} of leads move on.',
    insightStuck: 'Leads stay longest at the “{stage}” stage (avg. {days} days).',
    insightWin: 'Win rate {pct}: {won} won, {lost} lost.',
    insightOpen: '{count} open leads with a potential of {amount} are waiting in the funnel.',
    insightEmpty: 'No leads for the selected filters.',
    seeLeads: 'See leads',
    actions: { leads: 'Leads', customers: 'Customers', newCustomer: 'New customer', activity: 'Activity' },
  },
  bonus: {
    pool: 'Pool utilisation',
    poolHint: 'base pool {amount}',
    forPeriod: 'for {month}',
    gain: 'Possible increase',
    gainHint: 'after the best step',
    gainNone: 'maximum reached',
    insightBelow: '{count} of {total} reps do not reach the sales threshold — no sales component.',
    insightPenalty: '{count} reps lose part of their bonus because of unmet mandatory activities.',
    insightTop: 'Highest bonus: {name} — {amount}.',
    insightTip: 'Fastest way to a higher bonus: {tip} (+{gain}).',
    insightEmpty: 'No reps to calculate a bonus for in this period.',
    actions: { activity: 'Activity', mine: 'My results', team: 'Team' },
  },
  live: {
    online: 'Reps online',
    onlineHint: 'of {total} in scope',
    onVisit: 'On a visit',
    onVisitHint: 'on average {duration} at the customer',
    onVisitNone: 'no visit in progress',
    visits: 'Visits today',
    visitsHint: '{inProgress} in progress · {planned} to go',
    gps: 'No fresh signal',
    gpsHint: '{none} without GPS · {lost} silent > 1 h',
    gpsOk: 'everyone is reporting a position',
    insightLost: 'No GPS signal for over an hour: {names}.',
    insightLong: 'The longest visit lasts {duration} — {rep} at {customer}.',
    insightIdle: 'Nobody is on a visit right now, while {online} reps are online.',
    insightOk: 'All reps have an active signal, on a visit: {onVisit}.',
    locate: 'Show on map',
    actions: { fit: 'Whole map', customers: 'Customers', alerts: 'Alerts', activity: 'Activity' },
  },
  ai: {
    questions: 'Questions this month',
    questionsHint: 'today: {today}',
    cost: 'Cost this month',
    costHint: 'budget {amount}',
    costNoBudget: 'no budget limit',
    projection: 'End-of-month forecast',
    projectionHint: '{pct} of budget',
    projectionDays: 'day {elapsed} of {total}',
    tokens: 'Tokens',
    tokensHint: '{calls} calls · cache {cache}',
    insightOver: 'Cost forecast of {projection} exceeds the {budget} budget — reduce usage or raise the limit.',
    insightNear: '{pct} of the monthly budget is already used (cost {cost}).',
    insightMock: 'The assistant runs in demo (mock) mode — costs are simulated.',
    insightTopUser: 'Most active user: {name} — {questions} questions, {cost} ({share} of cost).',
    insightEmpty: 'No AI assistant usage this month.',
    actions: { users: 'Users', board: 'Board dashboard' },
  },
  soon: {
    status: 'Status',
    statusValue: 'Coming soon',
    statusHint: 'module in preparation',
    milestone: 'Planned milestone',
    insight: 'This module is in preparation (milestone {milestone}). Until then, use the other views.',
    actions: { home: 'My day', analytics: 'Analytics' },
  },
  hub: {
    available: 'Available dashboards',
    availableHint: 'of {total} in the system',
    scope: 'Data scope',
    scopeOrg: 'Whole organization',
    scopeTeam: 'Team',
    scopeOwn: 'Own data',
    scopeHint: 'based on your permissions',
    insightBoard: 'Start with the Board dashboard — consolidated results of the whole organization.',
    insightTeam: 'Start with the Team dashboard — rep results against targets.',
    insightRep: 'Start with “My results” — your sales, targets and visits.',
    insightOpen: 'Open',
    pick: 'Pick a dashboard',
    pickHint: 'Every view respects your data scope and permissions.',
    desc: {
      board: 'Whole-organization results: sales, margin, targets and trends.',
      team: 'Team and rep results against targets.',
      rep: 'Your sales, target attainment and customers.',
      activity: 'Visits, portfolio coverage, GPS discipline and anomalies.',
      funnel: 'The path from lead to first order and source effectiveness.',
      bonus: 'Bonus simulator and “My bonus”.',
      customers: 'Segments, ABC, churn risk and purchase patterns.',
      products: 'Products, categories, basket and assortment turnover.',
      margin: 'Margin by customer, product and period.',
      forecasts: 'Sales and target-attainment forecasts.',
      receivables: 'Receivables, overdue amounts and payment risk.',
      profitability: 'Profitability of customers and delivery routes.',
    },
  },
  users: {
    total: 'Accounts',
    totalHint: 'roles in use: {roles}',
    active: 'Active',
    activeHint: '{share} of accounts',
    inactive: 'Inactive',
    inactiveHint: 'blocked accounts',
    lastLogin: 'last sign-in {when}',
    twoFa: '2FA verification',
    twoFaHint: '{count} of {total} active accounts',
    insightAdmin2fa: 'Administrators without two-factor authentication: {count}. Enable 2FA before handing access to the client.',
    insightInactive: 'Inactive accounts: {count}. Blocked users cannot sign in.',
    insightOk: 'All accounts are active and access matches roles.',
    actions: { roles: 'Roles and permissions', audit: 'Audit log' },
  },
  roles: {
    roles: 'Roles',
    rolesHint: 'from board to collections',
    permissions: 'Permissions',
    permissionsHint: 'in the system catalogue',
    groups: 'Areas',
    groupsHint: 'customers, BI, approvals…',
    narrowest: 'Narrowest role',
    insight: 'Data scope (own, team, whole company) is enforced by the server — the roles view is read-only.',
    actionUsers: 'Users',
  },
  audit: {
    total: 'Log events',
    totalHint: 'total, newest first',
    day: 'Last 24 hours',
    dayHint: '{actors} users were active',
    logins: 'Sign-ins',
    loginsHint: 'successful, 24 h',
    failed: 'Failed sign-ins',
    failedHint: '24 h',
    insightFailed: 'Failed sign-ins in the last day: {count}. Check the IP addresses and accounts involved.',
    insightSomeFailed: 'A few failed sign-ins in the last day: {count}.',
    insightOk: 'No failed sign-ins in the last day.',
  },
  help: {
    insight: 'Start with “My day” — tasks, alerts and target progress in one place. Ctrl K opens search.',
    actions: { myDay: 'My day', customers: 'Customers', tasks: 'Tasks', analytics: 'Analytics' },
  },
  legal: {
    insight: 'Documents are demo versions — binding versions will be signed before the production launch.',
    actions: { help: 'Help and FAQ' },
  },
};
